export default __webpack_public_path__ + "static/media/GuyAnimation3.b24c06d7.svg";